import { CUSTOM_EVENTS } from '../cfg/constants/game-constants';
// var gameanalytics = require("gameanalytics");
// gameanalytics.GameAnalytics.setEnabledInfoLog(true);
// gameanalytics.GameAnalytics.setEnabledVerboseLog(true);
// gameanalytics.GameAnalytics.configureBuild("0.10");
// gameanalytics.GameAnalytics.initialize("98886ddafebbbd7c6cc6b0504fc4cd53", "8534c19b4895a0c6d3d5cfa42597cf28c02178d5");
// let fields = {
//   test: 100,
//   test_2: "hello_world",
// };
// gameanalytics.GameAnalytics.addErrorEvent(
//   gameanalytics.EGAErrorSeverity.Debug,
//   "is button clicked",
//   fields
// );
// gameanalytics.GameAnalytics.addDesignEvent("BossFights:FireLord:KillTimeUsed", 234);
// import {GameAnalytics} from 'gameanalytics';
// GameAnalytics.setEnabledInfoLog(true);
// GameAnalytics.setEnabledVerboseLog(true);
// GameAnalytics.initialize("98886ddafebbbd7c6cc6b0504fc4cd53", "8534c19b4895a0c6d3d5cfa42597cf28c02178d5");
// GameAnalytics.addDesignEvent({
// 	eventId: "level1:completed" // Example: "level1:completed"
// });
// GameAnalytics.addProgressionEvent({
// 	progression01: "world_1",
// 	progression02: "level_1"
// });
// interface Heap {
//   track: (event: string, properties?: Object) => void;
//   identify: (identity: string) => void;
//   resetIdentity: () => void;
//   addUserProperties: (properties: Object) => void;
//   addEventProperties: (properties: Object) => void;
//   removeEventProperty: (property: string) => void;
//   clearEventProperties: () => void;
//   appid: string;
//   userId: string;
//   identity: string | null;
//   config: any;
// }
export class StartScreen {
    constructor(scene) {
        this.scene = scene;
        this.optionSelected = 1;
        this.nextScreenCounter = 0;
        this.colorCode = {
            gameTitleTextHex: "#ffffff",
            MenuBox1Hex: 0x5265e4,
            MenuBox1TextHex: "#ffffff",
            MenuBox2Hex: 0xfc6f42,
            MenuBox2TextHex: "#442c2E",
            MenuBox3Hex: 0xffc73b,
            MenuBox3TextHex: "#ffffff",
            disclaimerHeaderHex: "#000000",
            disclaimerBodyHex: "#000000",
            titleTextHex: "#ffffff",
            descriptionTextHex: "#ffffff",
            startButtonTextHex: "#000000",
        };
        this.bg = this.scene.add.image(0, 0, 'whiteBG').setScale(5).setDepth(999);
        this.topLogo = this.scene.add.image(25, -500, 'varsityLogo').setScale(0.3).setDepth(1000).setVisible(false);
        this.poweredByText = this.scene.add.text(-100, 450, 'POWERED BY', { font: '25px Arial' }).setOrigin(0.5).setDepth(999);
        this.bottomLogo = this.scene.add.image(this.poweredByText.x + this.poweredByText.width * this.poweredByText.scaleX, this.poweredByText.y, 'PPPLogo').setScale(0.07).setDepth(1000);
        const buttonConfig = { font: '75px Arial' };
        this.scene.globalEvents.on(CUSTOM_EVENTS.SHOW_START_SCREEN, () => {
            this.ShowStartScreen();
        });
        this.gamesCardBox1 = this.scene.add.sprite(0, -200, "longButton").setScale(2).setDepth(999);
        this.gamesCardBox1.setTint(this.colorCode.MenuBox1Hex);
        this.gamesCardBox2 = this.scene.add.sprite(0, 0, "longButton").setScale(2).setDepth(999);
        this.gamesCardBox2.setTint(this.colorCode.MenuBox2Hex);
        this.gamesCardBox3 = this.scene.add.sprite(0, 200, "longButton").setScale(2).setDepth(999);
        this.gamesCardBox3.setTint(this.colorCode.MenuBox3Hex);
        this.gameTitleText = this.scene.add.text(0, -340, 'PLAY YOUR GAME', buttonConfig).setOrigin(0.5).setDepth(999);
        this.gameTitleText.setColor(this.colorCode.gameTitleTextHex);
        this.gameTitleText.setFontSize("50px");
        this.gameOption1 = this.scene.add.text(this.gamesCardBox1.x, this.gamesCardBox1.y, 'Trends', buttonConfig).setOrigin(0.5).setDepth(999).setInteractive().setVisible(true);
        this.gameOption2 = this.scene.add.text(this.gamesCardBox2.x, this.gamesCardBox2.y, 'Pick the Pic', buttonConfig).setOrigin(0.5).setDepth(999).setInteractive().setVisible(true);
        this.gameOption3 = this.scene.add.text(this.gamesCardBox3.x, this.gamesCardBox3.y, 'Pin it', buttonConfig).setOrigin(0.5).setDepth(999).setInteractive().setVisible(true);
        this.gameOption1.setColor(this.colorCode.MenuBox1TextHex);
        this.gameOption2.setColor(this.colorCode.MenuBox2TextHex);
        this.gameOption3.setColor(this.colorCode.MenuBox3TextHex);
        this.gamesCardBox2.setAlpha(0.5);
        this.gamesCardBox3.setAlpha(0.5);
        this.gameOption2.setAlpha(0.5);
        this.gameOption3.setAlpha(0.5);
        this.disclaimerText = this.scene.add.image(0, 550, "disclaimer").setScale(1).setDepth(999).setInteractive().setVisible(true);
        let disclaimerPopup = this.scene.add.sprite(0, -25, "popup1").setScale(1.8).setDepth(999).setVisible(false);
        let disclaimerHeader = this.scene.add.text(disclaimerPopup.x, disclaimerPopup.y - 250, 'DISCLAIMER', {
            font: '32px Arial',
        }).setOrigin(0.5).setVisible(false).setDepth(999);
        disclaimerHeader.setColor(this.colorCode.disclaimerHeaderHex);
        let disclaimerBodyText = this.scene.add.text(disclaimerPopup.x - 285, disclaimerPopup.y, '\n\n\nThis game prototype is only meant for the purpose of\ndemo, evaluation and testing and shall not be used for\nany other purposes whatsoever.\n\n\n\nAll intellectual property rights hereto belong to\nMs. Mugdha Sreekumar Variyar representing the\ncompany Pink Paper Play Pvt. Ltd., under incorporation or\nwith such other name as approved by the Ministry of\nCorporate Affairs.', {
            font: '37px Arial',
            align: "left",
        }).setOrigin(0, 0.5).setVisible(false).setDepth(999);
        disclaimerBodyText.setFontFamily("GameFontMedium");
        disclaimerBodyText.setColor(this.colorCode.disclaimerBodyHex);
        let closeButton = this.scene.add.sprite(disclaimerPopup.x + disclaimerPopup.scaleX * disclaimerPopup.width * 0.4, disclaimerPopup.y - disclaimerPopup.scaleY * disclaimerPopup.height * 0.4, "closeButton").setScale(0.15).setDepth(999).setVisible(false).setInteractive();
        this.disclaimerText.on("pointerup", () => {
            // Heap.track('Purchase', {dollars: 50, item: 'Furby'});
            disclaimerPopup.setVisible(true);
            disclaimerHeader.setVisible(true);
            disclaimerBodyText.setVisible(true);
            closeButton.setVisible(true);
        });
        closeButton.on("pointerup", () => {
            disclaimerPopup.setVisible(false);
            disclaimerHeader.setVisible(false);
            disclaimerBodyText.setVisible(false);
            closeButton.setVisible(false);
        });
        this.gameTitleText.setVisible(false);
        this.gamesCardBox1.setVisible(false);
        this.gamesCardBox2.setVisible(false);
        this.gamesCardBox3.setVisible(false);
        this.gameOption1.setVisible(false);
        this.gameOption2.setVisible(false);
        this.gameOption3.setVisible(false);
        this.disclaimerText.setVisible(false);
        this.optionSelected = 2;
        this.StartScreen();
        this.gameOption1.on("pointerup", (pointer) => {
            this.gameOption1.disableInteractive();
            this.scene.tweens.add({
                targets: this.gamesCardBox1,
                scale: this.gamesCardBox1.scale - 0.3,
                duration: 150,
                ease: 'Linear',
                yoyo: true,
                onComplete: () => {
                }
            });
            this.scene.tweens.add({
                targets: this.gameOption1,
                scale: this.gameOption1.scale - 0.3,
                duration: 150,
                ease: 'Linear',
                yoyo: true,
                completeDelay: 150,
                onComplete: () => {
                    this.GoNextScreen();
                }
            });
        });
    }
    GoNextScreen() {
        this.optionSelected = 2;
        this.gamesCardBox1.setVisible(false);
        this.gamesCardBox2.setVisible(false);
        this.gamesCardBox3.setVisible(false);
        this.gameTitleText.setVisible(false);
        this.gameOption1.setVisible(false);
        this.gameOption2.setVisible(false);
        this.gameOption3.setVisible(false);
        this.disclaimerText.setVisible(false);
        this.StartScreen();
    }
    StartScreen() {
        gtag("event", "start_page", {
            screen_name: "start_page",
        });
        const buttonConfig = { font: '45px Arial' };
        this.logo = this.scene.add.sprite(0, -200, 'logo').setScale(0).setDepth(999);
        let headingStyle = {
            font: '175px GameFontBold',
            stroke: '#000000',
            strokeThickness: 5,
            shadow: {
                offsetX: 0,
                offsetY: 1,
                color: '#ffffff',
                blur: 0,
                stroke: true,
                fill: false
            }
        };
        this.logoText = this.scene.add.text(0, -200, '#TRENDS', headingStyle).setOrigin(0.5).setDepth(999);
        this.bg.setTexture('bg1');
        this.titleText = this.scene.add.text(0, -50, 'TRENDS', buttonConfig).setOrigin(0.5).setDepth(999);
        this.titleText.setColor(this.colorCode.titleTextHex);
        this.titleText.setFontSize("100px");
        this.titleText.setFontFamily("GameFont");
        this.titleText.setAlpha(0);
        this.descriptionText = this.scene.add.sprite(0, 0, 'spotText').setScale(0.6).setDepth(999).setVisible(false);
        this.descriptionTextTitleText = this.scene.add.text(0, 0, 'Select three right answers that match the given trend', { font: '30px GameFont', align: "center", padding: { top: 100, bottom: 100 }, wordWrap: { width: this.descriptionText.width * 0.72 } }).setOrigin(0.5).setDepth(999);
        // this.descriptionText = this.scene.add.text(0, 50, 'Spot three news stories\nthat match the #trend', buttonConfig).setOrigin(0.5).setDepth(999);
        // this.descriptionText.setColor(this.colorCode.descriptionTextHex);
        // this.descriptionText.setAlign("center");
        // this.descriptionText.setFontSize("50px");
        // this.descriptionText.setFontFamily("GameFontMedium")
        this.startButton = this.scene.add.sprite(0, 150, 'start').setScale(0.6).setInteractive().setDepth(999);
        this.startButtonText = this.scene.add.text(this.startButton.x, this.startButton.y, 'PLAY', buttonConfig).setOrigin(0.5).setDepth(999).setScale(0);
        this.startButtonText.setColor(this.colorCode.startButtonTextHex);
        this.startButtonText.setFontFamily("GameFontMedium");
        this.startButton.on("pointerup", () => {
            if (this.nextScreenCounter == 3) {
                this.topLogo.setVisible(false);
                this.bottomLogo.setVisible(false);
                this.poweredByText.setVisible(false);
                this.logo.setVisible(false);
                this.logoText.setVisible(false);
                this.descriptionText.setVisible(false);
                this.descriptionTextTitleText.setVisible(false);
                this.bg.setVisible(false);
                this.titleText.setVisible(false);
                this.startButton.setVisible(false);
                this.startButtonText.setVisible(false);
                this.scene.globalEvents.emit(CUSTOM_EVENTS.RESET_GAME);
                return;
            }
            this.nextScreenCounter++;
            if (this.nextScreenCounter == 1) {
                gtag("event", "Start_btn", {
                    screen_name: "landing_page",
                });
                this.topLogo.setVisible(false);
                this.bottomLogo.setVisible(false);
                this.poweredByText.setVisible(false);
                this.logo.setTexture("popup");
                this.logo.y += 100;
                this.logo.setScale(0.6);
                this.descriptionText.setVisible(false);
                this.logoText.setVisible(false);
                this.descriptionText.setVisible(false);
                this.descriptionTextTitleText.setVisible(false);
                this.startButton.setTexture("play");
                this.startButton.y += 200;
                this.startButtonText.setVisible(false);
                gtag("event", "instruction_page", {
                    screen_name: "instruction_page",
                });
            }
            if (this.nextScreenCounter == 2) {
                gtag("event", "play_btn", {
                    screen_name: "landing_page",
                });
                this.topLogo.setVisible(false);
                this.bottomLogo.setVisible(false);
                this.poweredByText.setVisible(false);
                this.logo.setScale(0);
                this.logo.setVisible(false);
                this.logoText.setVisible(false);
                this.descriptionText.setVisible(false);
                this.descriptionTextTitleText.setVisible(false);
                this.bg.setVisible(false);
                this.titleText.setVisible(false);
                this.startButton.setVisible(false);
                this.startButtonText.setVisible(false);
                if (this.optionSelected == 1)
                    this.scene.globalEvents.emit(CUSTOM_EVENTS.SET_GAMESCREEN1);
                if (this.optionSelected == 2)
                    this.scene.globalEvents.emit(CUSTOM_EVENTS.SET_GAMESCREEN2);
                if (this.optionSelected == 3)
                    this.scene.globalEvents.emit(CUSTOM_EVENTS.SET_GAMESCREEN3);
            }
        });
    }
    ShowStartScreen() {
        // this.topLogo.setVisible(true);
        this.bottomLogo.setVisible(true);
        this.poweredByText.setVisible(true);
        this.nextScreenCounter = 3;
        this.logo.setVisible(true);
        this.logoText.setVisible(true);
        this.descriptionText.setVisible(false);
        this.descriptionTextTitleText.setVisible(true);
        this.bg.setVisible(true);
        this.titleText.setVisible(true);
        this.startButton.setVisible(true);
        this.startButtonText.setVisible(true);
    }
    resizeAndRepositionElements(w, h) {
        const width = w / this.bg.width;
        const height = h / this.bg.height;
        this.bg.setScale(width > height ? width : height);
    }
}
